import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ElementRef, ChangeDetectorRef, Inject, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { GroupService } from '../../services/group.service';

@Component({
  selector: 's18-stripe-payment',
  templateUrl: './stripe-payment.component.html',
  styleUrls: ['./stripe-payment.component.scss']
})
export class StripePaymentComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() paymentAmount: number;
  @Input() paymentComplete: boolean;
  @Output() paymentSuccess = new EventEmitter<any>();
  @Output() paymentFailure = new EventEmitter<any>();

  @ViewChild('cardInfo') cardInfo: ElementRef;
  card: any;
  cardHandler = this.onChange.bind(this);
  error: string;
  promoCode: string = '';
  discount: number = 0;
  displayPrice: number = 0;

  lookingForDiscount: boolean = false;
  processing: boolean = false;

  constructor(
    private groupService: GroupService,
    private cd: ChangeDetectorRef
  ) {

  }

  ngOnInit() {
    this.displayPrice = this.paymentAmount;
  }

  ngAfterViewInit() {
    this.card = elements.create('card');
    this.card.mount(this.cardInfo.nativeElement);

    this.card.addEventListener('change', this.cardHandler);
  }

  ngOnDestroy() {
    this.card.removeEventListener('change', this.cardHandler);
    this.card.destroy();
  }

  checkDiscount() {
    this.displayPrice = this.paymentAmount;
    this.discount = null;
    if (this.promoCode.length > 4) {
      this.lookingForDiscount = true;
      this.groupService.checkPromoCode(this.promoCode)
        .subscribe(resp => {
          this.lookingForDiscount = false;
          var response = JSON.parse(resp.d).response;
          if (response.amount_off) {
            this.discount = response.amount_off / 100;
          } else {
            this.discount = this.paymentAmount * response.percent_off / 100;
          }
          this.displayPrice = this.paymentAmount - this.discount;
        });
    }
  }

  getDisplayPrice() {
    if (this.paymentAmount - this.discount > 0) {
      return this.paymentAmount - this.discount;
    }
    return 0;
  }

  onChange({ error }) {
    if (error) {
      this.error = error.message;
    } else {
      this.error = null;
    }
    this.cd.detectChanges();
  }

  async onSubmit(form: NgForm) {
    this.processing = true;
    const { token, error } = await stripe.createToken(this.card);
    this.processing = false;

    if (error) {
      console.log('Something is wrong:', error);
      error.status = 'failed';
      this.paymentFailure.emit({ error });
    } else {
      console.log('Success!');
      token.couponCode = this.promoCode;
      token.price = this.displayPrice;
      token.s18_status = 'success';
      this.paymentSuccess.emit({ token });
      //this.dialogRef.close(token);
    }
  }

}
